<template>
  <div class="row" id="noticiasPagination" v-if="showPagination">
    <div class="small-12 medium-12 large-12 columns numeros_pag_noticia">
      <div class="numeros_noticias">
        <p class="numero_paginas_noticias" 
          :key="n"
          :class="{ active: n == currentPage }" 
          v-for="n in pages"
          @click="$emit('changePage', n)">{{ n }}</p>
      </div>
    </div>
  </div>
  <div class="row align-center loadmorewrapper" 
    v-if="!isLastPage && showPagination">
    <div class="small-12 medium-7 columns">
      <a class="loadmore" @click="$emit('loadmore')">{{ seeMoreLabel }}</a>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";

export default {
  props: ["showPagination", "currentPage", "numberOfPages"],
  emits: ["changePage", "loadmore"],
  setup(props) {
    const seeMoreLabel = ref('Ver mais');

    const pages = computed(() => {
      const generatePagesArray = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => i + start);
      if (props.numberOfPages < 8) {
        return generatePagesArray(1, props.numberOfPages);
      } else {
        if (props.currentPage < 5) {
          return [...generatePagesArray(1, 5), '...', props.numberOfPages];
        } else if (props.currentPage > props.numberOfPages - 4) {
          return [1, '...', ...generatePagesArray(props.numberOfPages - 4, props.numberOfPages)];
        } else {
          return [1, '...', props.currentPage - 1, props.currentPage, props.currentPage + 1, '...', props.numberOfPages];
        }
      }
    })

    const isLastPage = computed(() => props.currentPage == props.numberOfPages);

    return {
      seeMoreLabel,
      isLastPage,
      pages
    }

  }
}
</script>

<style scoped>
.numeros_pag_noticia {
  display: inline-flex;
  margin-top: 40px;
  margin-bottom: 0px;
}

.numeros_noticias {
  display: flex;
  margin: 0 auto;
}

.numero_paginas_noticias {
  padding-top: 10px;
  background: transparent;
  color: #666;
  font-family: "Montserrat Bold";
  padding-bottom: 10px;
  padding-right: 20px;
  padding-left: 18px;
  margin-right: 5px;
  margin-left: 5px;
  margin-bottom: 0px;
  letter-spacing: 0.6px;
  border-bottom: 3px solid transparent;
  transition: border .2s ease-out;
}

.numero_paginas_noticias.active {
  padding-top: 10px;
  border-bottom: 3px solid #6eb7ec;
  color: #404040;
  font-family: "Montserrat Bold";
  padding-bottom: 10px;
  padding-right: 20px;
  padding-left: 18px;
  margin-right: 5px;
  margin-left: 5px;
  letter-spacing: 0.6px;
  background: transparent;
  transition: border .2s ease-out;
}

.loadmorewrapper {
  display: none;
}

.numero_paginas_noticias:hover {
  cursor: pointer;
}

@media (max-width: 767px) {
  .numeros_pag_noticia {
    display: none;
  }

  .loadmorewrapper {
    display: flex;
    flex: 1;
  }

  .loadmorewrapper > .columns{
    padding-left: 0;
    padding-right: 0;
  }

  .loadmore,
  .loadmore:hover {
    font-family: 'Montserrat Bold';
    letter-spacing: 1.2px;
    background-color: transparent;
    border: 2px solid #454648;
    color: #454648;
    margin: 0 auto;
    text-align: center;
    text-transform: uppercase;
    justify-content: center;
    display: flex;
    padding: 11px;
    font-size: 14px;
    margin-top: 39px;
  }

  .loadmore,
  .loadmore:hover {
    color: #6eb7ec;
    border-color: #6eb7ec;
    border: 1px solid;
  }

  .loadmorewrapper a {
    font-size: 12px;
  }

  .loadmorewrapper a:hover {
    font-size: 12px;
  }

}
</style>